export default __webpack_public_path__ + "static/media/Walking in the Rainbow or in the barcode.5adf93b4.jpg";